import { Stack, Text, SimpleGrid, Card, Group, Badge, Box, ThemeIcon } from "@mantine/core";
import { NavLink as RouterNavLink } from "react-router-dom";
import { Utilities } from "../common/utilities";
import TableItemsCount from "../components/TableItemsCount";
import {
    IconTable,
    IconCertificate,
    IconReportMoney,
    IconInvoice,
    IconSchool,
    IconUsers,
    IconClipboardList,
    IconChevronRight,
    IconPackageExport,
} from "@tabler/icons-react";

export default function Dashboard() {
    // Icon mapping for each table type
    const iconMap: { [key: string]: any } = {
        "Access Codes": IconTable,
        "Videos": IconTable,
        "Instructor": IconUsers,
        "Tags": IconTable,
        // "Remittances": IconReportMoney,
        "Certification": IconCertificate,
        // "Remittance": IconReportMoney,
        "Invoice": IconInvoice,
        "Batches": IconSchool,
        "Students": IconUsers,
        "Attendance": IconClipboardList,
        "Package":IconPackageExport
    };

    // Color mapping for each table - light background + icon color
    const colorMap: { [key: string]: { bg: string; icon: string; light: string } } = {
        "Access Codes": { bg: "#667eea", icon: "#667eea", light: "#f0f4ff" },
        "Videos": { bg: "#f5576c", icon: "#f5576c", light: "#fef2f4" },
        "Instructor": { bg: "#10b981", icon: "#10b981", light: "#f0fdf4" },
        "Tags": { bg: "#f59e0b", icon: "#f59e0b", light: "#fffbeb" },
        // "Remittances": { bg: "#8b5cf6", icon: "#8b5cf6", light: "#faf5ff" },
        "Certification": { bg: "#06b6d4", icon: "#06b6d4", light: "#f0f9ff" },
        // "Remittance": { bg: "#ec4899", icon: "#ec4899", light: "#fdf2f8" },
        "Invoice": { bg: "#14b8a6", icon: "#14b8a6", light: "#f0fdfa" },
        "Batches": { bg: "#6366f1", icon: "#6366f1", light: "#f0f4ff" },
        "Students": { bg: "#f5576c", icon: "#f5576c", light: "#fef2f4" },
        "Attendance": { bg: "#fb923c", icon: "#fb923c", light: "#fef3f2" },
                "Package": { bg: "#fb923c", icon: "#fb923c", light: "#fef3f2" },

    };

    return (
        <Stack gap="sm">
            {/* Page Header */}
           
 {/* Data Tables Section */}
            <Box>
                <Box mb="xs">
                    <Text
                        size="sm"
                        fw={700}
                        style={{
                            color: '#1f2937',
                        }}
                    >
                        Data Tables
                    </Text>
                    <Text
                        size="10px"
                        style={{
                            color: '#6b7280',
                            marginTop: '2px',
                        }}
                    >
                        Manage system data
                    </Text>
                </Box>

                <SimpleGrid
                    cols={{ base: 1, sm: 2, md: 3, lg: 4 }}
                    spacing="xs"
                >
                    {Utilities.tablesToShow.map((table, idx) => {
                        const Icon = iconMap[table.label.plural] || IconTable;
                        const colors = colorMap[table.label.plural] || {
                            bg: "#667eea",
                            icon: "#667eea",
                            light: "#f0f4ff",
                        };

                        return (
                            <RouterNavLink
                                key={table.name.plural}
                                to={`/tables/${table.name.plural}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <Card
                                    component="div"
                                    style={{
                                        backgroundColor: colors.light,
                                        border: `1px solid ${colors.bg}20`,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        height: '100%',
                                    }}
                                    p="xs"
                                    radius="md"
                                    className="hover:shadow-md hover:scale-105 group"
                                >
                                    <Stack gap="xs">
                                        {/* Header Section */}
                                        <Group justify="space-between" align="flex-start">
                                            <Stack gap={0} style={{ flex: 1 }}>
                                                <Text
                                                    size="10px"
                                                    fw={600}
                                                    style={{
                                                        color: colors.icon,
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.3px',
                                                    }}
                                                >
                                                    {table.label.plural.split(' ')[0]}
                                                </Text>
                                                <Text
                                                    size="xs"
                                                    fw={700}
                                                    style={{
                                                        color: '#1f2937',
                                                        marginTop: '2px',
                                                    }}
                                                >
                                                    {table.label.plural}
                                                </Text>
                                            </Stack>
                                            <ThemeIcon
                                                variant="light"
                                                size="md"
                                                radius="md"
                                                style={{
                                                    // backgroundColor: '#ffffff',
                                                    color: colors.icon,
                                                    border: `1px solid ${colors.icon}20`,
                                                }}
                                            >
                                                <Icon size={16} />
                                            </ThemeIcon>
                                        </Group>

                                        {/* Footer Section with Record Count */}
                                        <Group justify="space-between" align="flex-end" gap="xs">
                                            <Stack gap="0">
                                                <Text
                                                    size="10px"
                                                    style={{
                                                        color: '#9ca3af',
                                                    }}
                                                >
                                                    Records
                                                </Text>
                                                <Box
                                                    style={{
                                                        color: colors.icon,
                                                        fontWeight: 700,
                                                        fontSize: '14px',
                                                        marginTop: '2px',
                                                    }}
                                                >
                                                    <TableItemsCount
                                                        label={table.label.plural}
                                                        apiPath={table.apiPath}
                                                    />
                                                </Box>
                                            </Stack>
                                            <IconChevronRight
                                                size={16}
                                                style={{
                                                    color: colors.icon,
                                                    transition: 'transform 0.2s ease',
                                                }}
                                                className="group-hover:translate-x-1"
                                            />
                                        </Group>
                                    </Stack>
                                </Card>
                            </RouterNavLink>
                        );
                    })}
                </SimpleGrid>
            </Box>
        </Stack>
    );
}